module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki02_sp-b497c3fc98c70c4e1a19c53d056d0c51.jpg";